import * as HTTP_REQUEST from "./api";
import { handleResponse } from "../utils/functions";

const MODEL_PATH = "/reporte/";

export const getTotales = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "totales");
  return handleResponse(response);
};

export const searchParticipante = async (search) => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "search/", search);
  return handleResponse(response);
};
